module.exports = __webpack_public_path__ + "img/colaboradores.69396683.webp";